import * as ActionTypes from "../Types/ActionTypes";

export const FeedbackAnswer = (
  state = {
    isLoading: true,
    errMess: null,
    feedbackAnswers: [],
  },
  action
) => {
  switch (action.type) {
    case ActionTypes.FETCH_FEEDBACKANSWERS:
      return {
        ...state,
        isLoading: false,
        errMess: null,
        feedbackAnswers: action.payload,
      };

    case ActionTypes.FEEDBACKANSWERS_LOADING:
      return {
        ...state,
        isLoading: true,
        errMess: null,
        feedbackAnswers: [],
      };

    case ActionTypes.FEEDBACKANSWERS_FAILED:
      return {
        ...state,
        isLoading: false,
        errMess: action.payload,
        feedbackAnswers: [],
      };

    default:
      return state;
  }
};
